import heart from './assets/heart.svg';
import eye from './assets/eye.svg';
import briefcase from './assets/briefcase.svg';

export const UTP = [
  {
    title: 'Спишем средства только за переход в карточку объявления из поиска, рекомендаций или карты',
    image: heart,
  },
  {
    title:
      'Если один человек смотрел одно и то же объявление несколько раз за один день — это один уникальный просмотр',
    image: eye,
  },
  {
    title: 'Не спишем средства, если объявление просмотрели ваши коллеги из агентства или вы сами',
    image: briefcase,
  },
];
